import { LoanExceptionStatus } from 'store/loanExceptions/types';

export const isPending = status =>
  status === LoanExceptionStatus.SUBMITTED || status === LoanExceptionStatus.UNDER_REVIEW;

export const getExceptionRows = ({
  exceptions,
  canEdit,
  canApprove,
  onEdit,
  onApprove,
  onDeny,
  onWithdraw,
}) =>
  exceptions.map(exception => ({
    ...exception,
    canEdit,
    canApprove,
    onEdit,
    onApprove,
    onDeny,
    onWithdraw,
  }));
